import { Component, EventEmitter, Input, OnDestroy, OnInit, Output } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { IClientInfo } from 'src/app/model/client-info.interface';
import { Fido2Helper } from '../../../../helpers/fido2.helper';
import { CidaasService } from './../../../../service/cidaas.service';
import { SharedDataService } from './../../../../service/shared-data.service';
import { LocationHelper, ILocation } from '../../../../helpers/location.helper';
import { EMPTY, from } from 'rxjs';
import {KEY_DEFAULT_ERROR} from '../../../../model/error.model';

@Component({
  selector: 'app-authenticate',
  templateUrl: './authenticate.component.html',
  styleUrls: ['./authenticate.component.scss'],
})
export class AuthenticateComponent implements OnInit, OnDestroy {
  @Input() options;
  inputGroupOption: any = {};
  isLoginBtn: boolean = true;
  password;
  username: string = '';
  requestId: string = '';
  verificationType: string = '';
  verificationType_CamelCase: string = '';
  exchangeId: string = '';
  statusId: string = '';
  push_selected_number: number = 0;
  navigator: any = window.navigator;
  fido2_entity: any;
  usernameType: string = '';
  forgotPwdOption: any = {
    text: 'LOGIN.FORGOT_PASSWORD',
    color: 'accent',
  };
  rememberMe: boolean = false;
  errorMessage = '';
  loginError: any;
  linkId: string = '';
  sub: any;
  fidoAuthenticateResponse: any;
  location: ILocation = {
    lat: '',
    lon: '',
  };
  timeoutEvent: any;
  pageLoading: boolean = false;

  @Output() notificationStatus = new EventEmitter<string>();

  constructor(
    private activatedRoute: ActivatedRoute,
    private _dataService: SharedDataService,
    private _cidaasSDK: CidaasService,
    private fidoHelper: Fido2Helper,
    private router: Router
  ) { }

  ngOnInit(): void {
    // getting values from query params
    this.getLatLon();
    this._initQueryparamValues();
    if (this.options) {
      this._initInputValues(this.options);
    }
    this.getClientInfo();
    this.getLoginError();

      setTimeout(() => this.acidCustomFocusOrder(), 0);

  }

    acidCustomFocusOrder() {
        const loginButton = document.querySelector('.login-btn') as HTMLElement;
        const forgotPwLink = document.querySelector('.gl-forgot-pw') as HTMLElement;
        const errorMessage = document.querySelector('.mat-error.custom') as HTMLElement;

        if (!loginButton || !forgotPwLink || !errorMessage) return;

        const container = loginButton.parentElement;
        if (!container) return;

        // Wrapper erstellen
        const wrapper = document.createElement('div');
        wrapper.style.position = 'relative';
        wrapper.style.width = '100%';
        wrapper.style.display = 'inline-flex';
        wrapper.style.justifyContent = 'end';

        // Passwort vergessen-Link in Wrapper legen
        forgotPwLink.parentElement?.insertBefore(wrapper, forgotPwLink);
        wrapper.appendChild(forgotPwLink);

        // Styling für Fokus-Reihenfolge per Flexbox
        forgotPwLink.style.order = '1';
        loginButton.style.order = '2';

        container.style.display = 'flex';
        container.style.flexDirection = 'column';

        // Wrapper (mit Link) vor Login-Button platzieren
        container.insertBefore(wrapper, loginButton);

        // --- NEU: Offset bei sichtbarer Fehlermeldung ---
        const checkAndApplyOffset = () => {
            const visible = errorMessage.offsetParent !== null;
            const content = errorMessage.textContent?.trim();

            if (visible && content) {
                forgotPwLink.style.transform = 'translateY(7px)';
            } else {
                forgotPwLink.style.transform = 'translateY(-40px)';
            }
        };

        // Initial prüfen
        checkAndApplyOffset();

        // MutationObserver beobachten Änderungen am Text
        const observer = new MutationObserver(() => {
            checkAndApplyOffset();
        });

        observer.observe(errorMessage, {
            childList: true,
            subtree: true,
            characterData: true,
        });
    }

  getLatLon(): void {
    const lat = localStorage.getItem('lat');
    const lon = localStorage.getItem('lon');
    if (lat && lon) {
      this.location.lat = lat;
      this.location.lon = lon;
    } else {
      LocationHelper.getLocationInfo().then((info: ILocation) => {
        this.location = info;
      }).catch((error) => {
        this.location.lat = '';
        this.location.lon = '';
      });
    }
  }

  // get client information
  getClientInfo(): void {
    this._dataService._getClientInfo().subscribe((data: IClientInfo) => {
      if (data) {
        if (data && data.is_remember_me_selected) {
          this.rememberMe = true;
        }
      }
    });
  }

  _initQueryparamValues = () => {
    this.activatedRoute.queryParams.subscribe((params) => {
      this.username = params['userIdHint'];
      this.requestId = params['requestId'];
      this.usernameType = params['type'];
      this.loginError = params['error'];
      this.linkId = params['linkId'];
    });
  };

  getLoginError() {
    if (this.loginError) {
      this.inputGroupOption['input'].value = '';
      this.inputGroupOption['input'].error = this.loginError.toUpperCase();
    }
  }

  _initInputValues = (options: any) => {
    options.subscribe((data) => {
      // [#1070](https://gitlab.widas.de/cidaas-v2/ui/issues/-/issues/1070) will remove the error message once we switch the MFA
      if(data) {
        this.errorMessage = '';
        clearTimeout(this.timeoutEvent)
        this.inputGroupOption['input'] = data['input'];
        this.inputGroupOption['button'] = data['button'];
        this.isLoginBtn = data['verify']['exchange_id'] || data['verify']['status_id'] ? false : true;
        this.verificationType = data['verify']['method'];
        this.verificationType_CamelCase = data['verify']['method'].toUpperCase();
        this.exchangeId = data['verify']['exchange_id'];
        this.sub = data['verify']['sub'];
        this.statusId = data['verify']['status_id'];
        this.push_selected_number = data['verify']['push_selected_number'];
        this.fido2_entity = data['verify']['fido2_entity'];
        if ((!this.exchangeId || this.exchangeId == undefined) && this.verificationType !== 'password') {
          this._verify('AUTHAPP');
        } else if (this.verificationType == 'fido2') {
          this._verify('FIDO2');
        }
      }
    });
  };

  _setCode = (data: any) => {
    if (data && data['value']) this.password = data['value'];
  };

  _login = () => {
    let options = {
      username: this.username,
      password: this.password,
      requestId: this.requestId,
      rememberMe: this.rememberMe,
      lat: this.location.lat,
      lon: this.location.lon
    };
    if(this.linkId) options["link-id"] = this.linkId;
    this._cidaasSDK._loginWithCredentials(options);
  };

  _verify = (type) => {
    this.pageLoading = true;

    if (type == 'CODE') {
      let options = {
        requestId: this.requestId,
        exchange_id: this.exchangeId,
        type: this.verificationType,
      };

      // #875 [Improvement] Verify Password in Verification-Srv during LOGIN WITH PASSWORD
      this.verificationType !== "password" ? options['pass_code'] = this.password : options['password'] = this.password;

      this._cidaasSDK
        .authenticateMFAV2(options)
        .then((response) => {
          if (response && response.success && response.data) {
            if (response.data['exchange_id'] && response.data['sub'] && response.data['status_id']) {
              this._intitiatePasswordlessLogin('CODE', response.data);
            } else {
              this._intitiatePasswordlessLogin('AUTHAPP', response.data);
            }
          } else {
            this.pageLoading = false;
            // [#949](https://gitlab.widas.de/cidaas-v2/ui/issues/-/issues/949) Invalid code coming when user enter wrong password in default-hosted-pages-webapp
            this.errorMessage = response?.error?.code ? `ERROR_CODES.VERIFICATION_SRV.AUTHENTICATE.${response?.error?.code}` : 'ERROR_CODES.RETRY';
          }
        })
        .catch((error) => {
          this.pageLoading = false;
          console.log(error);
        });
    } else if (type == 'AUTHAPP') {
      let options = {
        status_id: this.statusId,
      };
      this._intitiatePasswordlessLogin(type, options);
    } else if (type == 'FIDO2') {
      this.fidoVerification();
    } else {
      console.log("No match ", type);
    }
  };

  _intitiatePasswordlessLogin = (type: string, response: any) => {
    if (type == 'CODE') {
      let options = {
        requestId: this.requestId,
        exchange_id: response['exchange_id']['exchange_id'],
        verificationType: this.verificationType,
        sub: response['sub'],
        status_id: response['status_id'],
        rememberMe: this.rememberMe,
        lat: this.location.lat,
        lon: this.location.lon
      };
      if(this.linkId) options["link-id"] = this.linkId;
      this._cidaasSDK._passwordlessLogin(options);
    } else if (type == 'AUTHAPP') {
      this._checkStatus(response['status_id']);
    }
  };

  _checkStatus = (status_id: string) => {

    this._cidaasSDK
      ._checkStatusIDStatus(status_id)
      .then((data) => {
        if (data) {
          if (data.status == 'AUTHENTICATED') {
            let options = {
              requestId: this.requestId,
              verificationType: this.verificationType,
              sub: data['sub'],
              status_id: status_id,
              rememberMe: this.rememberMe,
              lat: this.location.lat,
              lon: this.location.lon
            };
            if(this.linkId) options["link-id"] = this.linkId;
            this._cidaasSDK._passwordlessLogin(options);
          } else {
            if (data.status == 'REJECTED_BY_USER' || data.status == 'AUTHENTICATION_CANCELLED') {
              clearTimeout(this.timeoutEvent);
              this.notificationStatus.emit(data.status);
            }
            else {
              this.timeoutEvent = setTimeout(() => {
                if (status_id) {
                  this._checkStatus(status_id);
                }
              }, 3000);
            }
          }
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  _submit = (isSubmitted) => {
    if (isSubmitted && this.password) {
      if (this.isLoginBtn) {
        this._login();
      } else {
        if (this.exchangeId) {
          this._verify('CODE');
        } else {
          this._verify('AUTHAPP');
        }
      }
    } else {
      this.inputGroupOption['input'].value = '';
      this.inputGroupOption['input'].error = 'REQUIRED_FIELD';
    }

  };

  _updatePassword = (password) => {
    this.password = password;
    if (this.inputGroupOption['input'] === undefined) {
      this.inputGroupOption['input'] = {};
    }
    this.inputGroupOption['input'].value = this.password ? this.password : '';
  };

  _initiateFido2 = () => {
    if (this.navigator.credentials && this.navigator.credentials.get) {
      let publicKey = this.fidoHelper.preformatGetAssertReq(this.fido2_entity.server_challenge);
      this.navigator.credentials.get({ publicKey }).then((response) => {
        let publicKeyCredential = this.fidoHelper.publicKeyCredentialToJSON(response);
        let options = {
          requestId: this.requestId,
          exchange_id: this.exchangeId,
          verificationType: this.verificationType,
          status_id: this.statusId,
          sub: this.sub,
          fido2_client_response: {
            client_response: publicKeyCredential,
            fidoRequestId: this.fido2_entity.fidoRequestId,
          },
          rememberMe: this.rememberMe,
          lat: this.location.lat,
          lon: this.location.lon
        };
        if(this.linkId) options["link-id"] = this.linkId;
        this._cidaasSDK._passwordlessLogin(options);
      });
    }
  };

  fidoVerification(): void {
    if (this.navigator.credentials && this.navigator.credentials.get) {
      let publicKey = this.fidoHelper.preformatGetAssertReq(this.fido2_entity.server_challenge);
      this.navigator.credentials.get({ publicKey }).then((response) => {
        let publicKeyCredential = this.fidoHelper.publicKeyCredentialToJSON(response);
        const authenticatePayload: any = {
          sub: this.sub,
          exchange_id: this.exchangeId,
          type: this.verificationType,
          fido2_client_response: {
            client_response: publicKeyCredential,
            fidoRequestId: this.fido2_entity.fidoRequestId,
          },
        };
        this._cidaasSDK
          .authenticateMFAV2(authenticatePayload)
          .then((data) => {
            if (data && data.success && data.data) {
              this.fidoAuthenticateResponse = data.data;
              this.callLogin();

            } else {
              this.errorMessage = KEY_DEFAULT_ERROR;
              console.log("Fido Authentication error")
            }
          })
          .catch((e) => {
            console.log("Fido Authentication error : ", e)
          });
      });
    }
  }

  callLogin() {
    let options = {
      requestId: this.requestId,
      exchange_id: this.exchangeId,
      verificationType: this.verificationType,
      sub: this.sub,
      status_id: this.fidoAuthenticateResponse.status_id,
      rememberMe: this.rememberMe,
      lat: this.location.lat,
      lon: this.location.lon,
    };
    if(this.linkId) options["link-id"] = this.linkId;
    this._cidaasSDK._passwordlessLogin(options);
  }

  forgotPassword() {
    this.router.navigate(['password_forgot_init'], {
      queryParams: {
        userIdHint: this.username,
        requestId: this.requestId,
        type: this.usernameType,
      },
    });
  }

  ngOnDestroy(): void {
    clearTimeout(this.timeoutEvent);
    this._dataService._clearMFAList();
  }
}
